package it.maicol07.gamerlogue.ui.views.settings.utils

enum class SettingsKeys {
    IS_DARK_THEME,
    LANGUAGE,
    USE_DYNAMIC_COLORS,
    SERVER_URL,
    IGDB_API_URL,
    CALENDAR_BACKLOG_ONLY,
    RATING_SCALE,
    REVIEW_MODE,
}
